<template>
  <div
    class="contact-form-loading"
    data-pw-form="contact-form-loading"
    role="status"
    aria-live="polite"
    aria-label="Loading contact form"
  >
    <svg
      class="contact-form-loading__spinner"
      data-pw-form="contact-form-spinner"
      width="50"
      height="50"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M20.0001 12C20.0001 13.3811 19.6425 14.7386 18.9623 15.9405C18.282 17.1424 17.3022 18.1477 16.1182 18.8587C14.9341 19.5696 13.5862 19.9619 12.2056 19.9974C10.825 20.0328 9.45873 19.7103 8.23975 19.0612"
        stroke="#000000"
        stroke-width="3.55556"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
  .contact-form-loading {
    display: flex;
    align-items: center; 
    justify-content: center;
    width: 100%;
    margin-top: 24px;
  }

  .contact-form-loading__spinner {
    width: 50px;
    height: 50px;
    transform-origin: center;
    animation: contact-form-loading-spin 0.8s linear infinite;
  }

  @keyframes contact-form-loading-spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>
